import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ScopeWrapper } from "@/components/ui/scope-wrapper";


interface Tab {
  id: string;
  label: string;
  icon: React.ReactElement;
  beta?: boolean;
  isActive?: boolean;
}

export default function CampaignTabs({ tabs }: { tabs: Tab[] }) {
  const location = useLocation();
  const pathSegments = location.pathname.split("/");
  const lastSegment = pathSegments[pathSegments.length - 1];

  // Find matching tab or fallback to first tab or "creators"
  const currentTab =
    tabs?.find((tab) => tab.id === lastSegment)?.id ||
    tabs?.find((tab) => tab.isActive)?.id ||
    tabs?.[0]?.id ||
    "creators";

  return (
    <Tabs value={currentTab}>
      <TabsList variant="underline">
        {tabs?.map((tab) => (
          <ScopeWrapper key={tab.id}>
            <NavLink
              key={tab.id}
              to={`${tab.id}`}
              className={({ isActive }) =>
                `group ${isActive ? "active-class" : ""}`
              }
            >
              <TabsTrigger value={tab.id}>
                <span className="lg:block hidden">{tab.icon}</span>
                {tab.label}
                {tab.beta && (
                  <span className="text-xs py-px px-1 rounded-xs border border-dashed border-warning/70 text-warning ml-1 rotate-6 scale-80 font-normal bg-background">
                    Beta
                  </span>
                )}
              </TabsTrigger>
            </NavLink>
          </ScopeWrapper>
        ))}
      </TabsList>
    </Tabs>
  );
}